import { render, staticRenderFns } from "./account.vue?vue&type=template&id=6090d750&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&id=6090d750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6090d750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6090d750')) {
      api.createRecord('6090d750', component.options)
    } else {
      api.reload('6090d750', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=6090d750&scoped=true&", function () {
      api.rerender('6090d750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/me/account.vue"
export default component.exports